import * as ActionTypes from './action-types.constants';

export const closeIfiModal = () => {
    return {
        type: ActionTypes.CLOSE_IFI_MODAL
    }
}